import styled from "styled-components";

export const LanguageSelection = styled.div`
  background: white;
  width: 100%;
  position: absolute;
  height: calc(100vh - 120px);
  top: 120px;
  z-index: 2;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  @media only screen and (min-width: 768px) {
    height: 547px;
  }
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: white;
  }
`;

export const Label = styled.p`
  font-size: 18px;
  color: ${({ selected, theme }) => (selected ? "white" : theme.colors.blue)};
  background: ${({ selected, theme }) => (selected ? theme.colors.blue : theme.colors.accent)};
  width: 100%;
  padding: 20px;
  margin: 0;
  cursor: pointer;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  &:first-child {
    border-top: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LanguageSelection.js